import {
  compose,
  propOr,
  values,
  map,
  chain,
  complement,
  isNil,
  converge,
  filter,
} from 'ramda';

import { SKU_BY_BENEFIT_SKU } from '../../constants/freeTrial';

const extractPackages = compose(
  chain(propOr([], 'products')),
  chain(values),
  propOr([], 'items'),
);

const extractSku = compose(sku => SKU_BY_BENEFIT_SKU[sku], propOr('', 'sku'));
const extractBenefits = compose(
  propOr([], 'benefits'),
  propOr([], 'benefit_package'),
);

const combineBenefitsAndSku = converge(
  (benefits, sku) => ({ benefits, sku }),
  [extractBenefits, extractSku],
);

const extractPriceFromBenefits = benefitName =>
  compose(item => {
    const { benefits, sku } = item;

    if (sku === undefined) {
      return null;
    }
    const requiredBenefit = benefits.find(benefit =>
      benefit.startsWith(benefitName),
    );

    if (requiredBenefit === undefined) {
      return null;
    }
    const [, , price, currency] = requiredBenefit.split('.');

    return {
      sku,
      values: {
        price,
        currency,
      },
    };
  }, combineBenefitsAndSku);

const extractStoreBenefits = compose(
  filter(complement(isNil)),
  map(extractPriceFromBenefits('cr_store.free_shipping_amount')),
  extractPackages,
);

export { extractStoreBenefits as StoreBenefits };
